import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@/App';
import '@/styles/globals.css';
import { telemetry } from '@lingugeek/telemetry-client';
import { ClientKind } from '@lingugeek/schemas';

if (import.meta.env.VITE_TELEMETRY_ENABLED === 'true') {
  telemetry.init({
    endpoint:
      import.meta.env.VITE_TELEMETRY_ENDPOINT ||
      `${import.meta.env.VITE_API_BASE_URL}/telemetry/errors`,
    token: import.meta.env.VITE_TELEMETRY_TOKEN || '',
    kind: ClientKind.Dashboard,
    enabled: true,
  });

  // Set release and environment info
  window.__APP_RELEASE__ = import.meta.env.VITE_APP_RELEASE || 'unknown';
  window.__APP_ENV__ = import.meta.env.VITE_APP_ENVIRONMENT || 'development';
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
